<template>
  <el-form-item
    :label="`${$t('TAG')}`"
    prop="company_vehicle_tags"
    v-loading="carTagsLoading"
    element-loading-spinner="el-icon-loading"
  >
    <el-select
      :disabled="ruleForm.disabled"
      v-model="ruleForm.company_vehicle_tags"
      clearable
      @change="$emit('tags', ruleForm.company_vehicle_tags)"
      @clear="$emit('clear')"
      @blur="$emit('blur')"
      @visible-change="handleVisibleChange"
      multiple
      collapse-tags
      filterable
      :placeholder="$t('SELECT_PLACEHOLDER')"
      :no-data-text="$t('NO_RESULT')"
    >
      <el-option
        v-for="item in carTags"
        :key="item.id + Math.random()"
        :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
        :value="item.id"
      ></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { getCarsTag } from '@/api/cars'
export default {
  props: ['value'],
  data() {
    return {
      ruleForm: {
        company_vehicle_tags: [],
      },

      carTags: [],
      carTagsLoading: true,
    }
  },

  methods: {
    handleVisibleChange(visible) {
      // When dropdown closes (visible becomes false), emit blur event
      if (!visible) {
        this.$emit('blur')
      }
    },
  },

  created() {
    getCarsTag.api().then((res) => {
      if (res) {
        this.carTags = res.sort((a, b) => {
          const nameA = a.fa_title?.toLowerCase() || ''
          const nameB = b.fa_title?.toLowerCase() || ''
          return nameA.localeCompare(nameB)
        })
        this.carTagsLoading = false
      }
    })
  },
  watch: {
    value(val) {
      if (!val || !Array.isArray(val) || (val.length === 1 && val[0] === ''))
        return

      const numberArray = val.map(Number)

      this.ruleForm.company_vehicle_tags = numberArray
    },
  },
}
</script>
